// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"TopArea-primaryButton-1qZ7TB","container":"TopArea-container-3CRhyx","rightSide":"TopArea-rightSide-1qSeYe"};